import useMapModalStore from '../../../../stores/useMapModalStore';
import WinstonCatModal from '../WinstonCatModal';
import { closeMapSelectionModal } from './closeMapSelectionModal';

/** Winston-cat monument modal (`activeModal === 'winstonCat'`). Fully store-driven. */
export default function WinstonCatHost() {
  const isWinstonCatModalOpen = useMapModalStore((s) => s.activeModal === 'winstonCat');

  return (
        <WinstonCatModal
          isOpen={isWinstonCatModalOpen}
          onClose={closeMapSelectionModal}
        />
  );
}
